<!-- header -->
<ahp-dashboard-header [merchantLocaleSuffix]="merchantLocaleSuffix"></ahp-dashboard-header>

<!-- memberships -->
<ahp-dashboard-memberships [merchantLocaleSuffix]="merchantLocaleSuffix"></ahp-dashboard-memberships>

<!-- bookings -->
<ahp-dashboard-bookings [merchantLocaleSuffix]="merchantLocaleSuffix"></ahp-dashboard-bookings>

<!-- recent orders -->
<ahp-dashboard-recent-orders [merchantLocaleSuffix]="merchantLocaleSuffix"></ahp-dashboard-recent-orders>

<!-- no payments -->
<ahp-dashboard-no-payments [merchantLocaleSuffix]="merchantLocaleSuffix"></ahp-dashboard-no-payments>

<!-- no orders -->
<ahp-dashboard-no-orders [merchantLocaleSuffix]="merchantLocaleSuffix"></ahp-dashboard-no-orders>
